module.exports = __webpack_public_path__ + "static/media/aan-het-woord.8dc6408d.jpg";